module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.styleShow != 'btn') ? _c('div', {
    staticClass: "addPictureBookBtn",
    on: {
      "click": _vm.openDialog
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.doWhatTemp === 'view'
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("添加资源")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "关联绘本",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formFuzzy,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资源名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": "输入书籍名称"
    },
    model: {
      value: (_vm.formFuzzy.bookName),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "bookName", $$v)
      },
      expression: "formFuzzy.bookName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资源ID:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "placeholder": "输入书籍ID"
    },
    model: {
      value: (_vm.formFuzzy.bookId),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "bookId", $$v)
      },
      expression: "formFuzzy.bookId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formFuzzy.bookBrand),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "bookBrand", $$v)
      },
      expression: "formFuzzy.bookBrand"
    }
  }, _vm._l((_vm.brandList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.label,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.queryData,
      "stripe": "",
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "资源名称",
      "align": "center",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "分类",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 10) ? _c('div', [_vm._v("绘本")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brand",
      "label": "品牌",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((JSON.parse(scope.row.content)).brand))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clevel",
      "label": "上下架状态",
      "width": "140",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.clevel == 2) ? _c('span', [_vm._v("编辑中")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 3) ? _c('span', [_vm._v("审核中")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 5) ? _c('span', [_vm._v("已上架")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 6) ? _c('span', [_vm._v("审核驳回")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 4) ? _c('span', [_vm._v("审核通过")]) : _vm._e(), _vm._v(" "), (scope.row.clevel == 0) ? _c('span', [_vm._v("已下架")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.dialogConfirm
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e1a7dec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/AddPictureBook.vue
// module id = 719
// module chunks = 1